import React from 'react';
import { createRoot } from 'react-dom/client';
import './style/index.scss';
import App from './component/app';
import reportWebVitals from './reportWebVitals';
import adapter from 'webrtc-adapter';
import './style/tailwind.min.css';
import { ACCESS_TOKEN, appId } from './constants';
import axios from 'axios';
const root = createRoot(document.getElementById('root')!);

root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
